import { isAskAIorAskLumappsEnabled, isAskAiAlphaEnabled } from '@lumapps/ask-lumapps/ducks/selectors';
import { isSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';
import { BackOfficeStore } from '@lumapps/redux/types';

/**
 * Retrieves whether the user can access the ask ai admin.
 */
export const canAccessAiAdmin = (state: BackOfficeStore) => isAskAIorAskLumappsEnabled(state) && isSuperAdmin(state);

/**
 * Retrieve whether the user can access tha ask ai admin features that are under development
 */
export const canAccessAiAlphaFeatures = createSelector(
    canAccessAiAdmin,
    isAskAiAlphaEnabled,
    (canAccessAiAdmin, isAskAiAlphaEnabled) => canAccessAiAdmin && isAskAiAlphaEnabled,
);
